import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Spin,
  Tooltip,
  Badge,
  Rate,
  Select,
  Popover,
  Modal,
  Layout,
  Menu,
  Button,
  Popconfirm,
  Input,
} from 'antd';
import {
  RiseOutlined,
  FileExcelOutlined,
  ScheduleOutlined,
  ProfileOutlined,
  LoadingOutlined,
  SearchOutlined,
  HomeOutlined,
  AlertOutlined,
  DollarCircleOutlined,
  InfoCircleOutlined,
  CreditCardOutlined,
  FireOutlined,
  ToolOutlined,
  TagOutlined,
  CarOutlined,
  BarChartOutlined,
  AppstoreOutlined,
  LineChartOutlined,
  TableOutlined,
  LeftOutlined,
  RightOutlined,
  UserOutlined,
  SettingOutlined,
  EditOutlined,
  VideoCameraOutlined,
  LinkOutlined,
} from '@ant-design/icons';
import {
  Switch,
  Route,
  NavLink,
  useHistory,
  Redirect,
  Link,
} from 'react-router-dom';

import MainDashboard from '../containers/mainDashboard';
import MainMetrico from '../containers/mainMetrico';
import Reports from '../containers/reports';
import DealerProfile from '../containers/dealerProfile';
import Profile from '../components/profile';
import Settings from '../components/settings';
import EvaluacionOptima from '../containers/evaluacionOptima';
import resumenGerencial from './resumenGerencial';
import EvaluacionGarantias from '../containers/evaluacionGarantias';
import DashboardServicios from '../containers/dashboardServicios';
import InventarioFisico from './inventarioFisico';
import inventarioRDSMxl from './inventariords';
import EvaluacionDesempeno from './evaluacionDesempeno/evaluacionDesempeno';
import Meeting from './meeting';

import logo from '../public/img/logo.png';

const { Search } = Input;
const { Option } = Select;
const { Header, Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;

const restrictedPuestos = [1, 4, 13, 5, 8, 9, 21, 11, 12, 14, 15, 17, 18]; // ID de puestos que solo podran ver el modulo de evaluacion de desempeño

function Main(props) {
  const history = useHistory();
  const [settingsVisible, setSettingsVisible] = useState(false);
  const [profileVisible, setProfileVisible] = useState(false);
  const [selectContainer, setSelectContainer] = useState(1);
  const code = useSelector((state) => state.main.code);
  const user = JSON.parse(localStorage.getItem('@@auth_user'));

  useEffect(() => {
    if (window.performance) {
      if (performance.navigation.type == 1) {
        if (isRestrictedUser) {
          history.push('/main/evaluacionDesempeno');
        } else {
          history.push('/main/resumenEjecutivoGO');
        }
      }
    }
  }, []);

  useEffect(() => {
    return history.listen((location) => {
      switch (location.pathname) {
        case '/main/resumenEjecutivoGO':
          setSelectContainer(1);
          break;
        case '/main/metrix':
          setSelectContainer(2);
          break;
        case '/main/dashboard':
          setSelectContainer(3);
          break;
        case '/main/reports':
          setSelectContainer(4);
          break;
        case '/main/evaluacionOptima':
          setSelectContainer(5);
          break;
        case '/main/resumenGerencial':
          setSelectContainer(6);
          break;
        case '/main/evaluacionGarantias':
          setSelectContainer(7);
          break;
        case '/main/dashboardServicios':
          setSelectContainer(8);
          break;
        case '/main/inventariosFisicos':
          setSelectContainer(9);
          break;
        case '/main/inventarioRDSMxl':
          setSelectContainer(10);
          break;
        case '/main/evaluacionDesempeno':
          setSelectContainer(11);
          break;
        case '/main/meeting':
          setSelectContainer(12);
          break;
      }
    });
  }, [history]);

  function logOff() {
    localStorage.removeItem('@@auth_user');
    history.push('/');
  }

  const isRestrictedUser = restrictedPuestos.includes(user.puesto);

  return user || code === 0 ? (
    <Layout style={{ height: '100vh' }}>
      <Profile
        setVisible={setProfileVisible}
        visible={profileVisible}
        logOff={logOff}
      />
      <Settings setVisible={setSettingsVisible} visible={settingsVisible} />

      <Sider
        width={50}
        style={{ height: '100vh', width: 50, background: 'black' }}
      >
        <div style={{ display: 'flex', flexFlow: 'column', height: '99vh' }}>
          <div style={{ height: '90vh', marginTop: 8 }}>
            {!isRestrictedUser && (
              <>
                <Popover
                  content={'Resumen Ejecutivo | Grupo Óptima'}
                  trigger="hover"
                  placement="left"
                >
                  <Button
                    style={{ fontSize: 16 }}
                    className={
                      selectContainer === 1
                        ? 'm-color-white m-background-blue-system'
                        : 'm-color-white'
                    }
                    size="large"
                    type="link"
                    onClick={() => setSelectContainer(1)}
                  >
                    <Link to="/main/resumenEjecutivoGO">
                      <HomeOutlined />{' '}
                    </Link>
                  </Button>
                </Popover>

                <Popover
                  content={'Dashboard Talleres de Servicio'}
                  trigger="hover"
                  placement="left"
                >
                  <Button
                    style={{ fontSize: 16 }}
                    className={
                      selectContainer === 8
                        ? 'm-color-white m-background-blue-system'
                        : 'm-color-white'
                    }
                    size="large"
                    type="link"
                    onClick={() => setSelectContainer(8)}
                  >
                    <Link to="/main/dashboardServicios">
                      <BarChartOutlined />{' '}
                    </Link>
                  </Button>
                </Popover>

                <Popover
                  content={'Resumen Gerencial'}
                  trigger="hover"
                  placement="left"
                >
                  <Button
                    style={{ fontSize: 16 }}
                    className={
                      selectContainer === 6
                        ? 'm-color-white m-background-blue-system'
                        : 'm-color-white'
                    }
                    size="large"
                    type="link"
                    onClick={() => setSelectContainer(6)}
                  >
                    <Link to="/main/resumenGerencial">
                      <ProfileOutlined />{' '}
                    </Link>
                  </Button>
                </Popover>

                <Popover content={'Métricos'} trigger="hover" placement="left">
                  <Button
                    style={{ fontSize: 16 }}
                    className={
                      selectContainer === 2
                        ? 'm-color-white m-background-blue-system'
                        : 'm-color-white'
                    }
                    size="large"
                    type="link"
                    onClick={() => setSelectContainer(2)}
                  >
                    <Link to="/main/metrix">
                      <RiseOutlined />{' '}
                    </Link>
                  </Button>
                </Popover>

                <Popover content={'Reportes'} trigger="hover" placement="left">
                  <Badge
                    count={0}
                    offset={[-10, 8]}
                    style={{ backgroundColor: '#FF952B' }}
                  >
                    <Button
                      style={{ fontSize: 16 }}
                      className={
                        selectContainer === 4
                          ? 'm-color-white m-background-blue-system'
                          : 'm-color-white'
                      }
                      size="large"
                      type="link"
                      onClick={() => setSelectContainer(4)}
                    >
                      <Link to="/main/reports">
                        {' '}
                        <FileExcelOutlined />
                      </Link>
                    </Button>
                  </Badge>
                </Popover>

                <Popover
                  content={'Evaluacion optima'}
                  trigger="hover"
                  placement="left"
                >
                  <Button
                    style={{ fontSize: 16 }}
                    className={
                      selectContainer === 5
                        ? 'm-color-white m-background-blue-system'
                        : 'm-color-white'
                    }
                    size="large"
                    type="link"
                    onClick={() => setSelectContainer(5)}
                  >
                    <Link to="/main/evaluacionOptima">
                      <ScheduleOutlined />{' '}
                    </Link>
                  </Button>
                </Popover>

                <Popover
                  content={'Evaluacion Garantias'}
                  trigger="hover"
                  placement="left"
                >
                  <Button
                    style={{ fontSize: 16 }}
                    className={
                      selectContainer === 7
                        ? 'm-color-white m-background-blue-system'
                        : 'm-color-white'
                    }
                    size="large"
                    type="link"
                    onClick={() => setSelectContainer(7)}
                  >
                    <Link to="/main/evaluacionGarantias">
                      <EditOutlined />{' '}
                    </Link>
                  </Button>
                </Popover>

                <Popover
                  content={'Inventarios Fisicos'}
                  trigger="hover"
                  placement="left"
                >
                  <Button
                    style={{ fontSize: 16 }}
                    className={
                      selectContainer === 9
                        ? 'm-color-white m-background-blue-system'
                        : 'm-color-white'
                    }
                    size="large"
                    type="link"
                    onClick={() => setSelectContainer(9)}
                  >
                    <Link to="/main/inventarioFisico">
                      <ProfileOutlined />{' '}
                    </Link>
                  </Button>
                </Popover>
                <Popover
                  content={'Inventarios RDS Mxli'}
                  trigger="hover"
                  placement="left"
                >
                  <Button
                    style={{ fontSize: 16 }}
                    className={
                      selectContainer === 10
                        ? 'm-color-white m-background-blue-system'
                        : 'm-color-white'
                    }
                    size="large"
                    type="link"
                    onClick={() => setSelectContainer(10)}
                  >
                    <Link to="/main/inventarioRDSMxl">
                      <ProfileOutlined />{' '}
                    </Link>
                  </Button>
                </Popover>
              </>
            )}
            <Popover
              content={'Evaluación de Desempeño'}
              trigger="hover"
              placement="left"
            >
              <Button
                style={{ fontSize: 16 }}
                className={
                  selectContainer === 11
                    ? 'm-color-white m-background-blue-system'
                    : 'm-color-white'
                }
                size="large"
                type="link"
                onClick={() => setSelectContainer(11)}
              >
                <Link to="/main/evaluacionDesempeno">
                  <LineChartOutlined />{' '}
                </Link>
              </Button>
            </Popover>
            <Popover content={'Meeting'} trigger="hover" placement="left">
              <Button
                style={{ fontSize: 16 }}
                className={
                  selectContainer === 12
                    ? 'm-color-white m-background-blue-system'
                    : 'm-color-white'
                }
                size="large"
                type="link"
                onClick={() => setSelectContainer(12)}
              >
                <Link to="/main/meeting">
                  <VideoCameraOutlined />{' '}
                </Link>
              </Button>
            </Popover>

            <Popover
              content={'IndicadoresDiarios'}
              trigger="hover"
              placement="left"
            >
              <Button
                style={{ fontSize: 16 }}
                className={
                  selectContainer === 13
                    ? 'm-color-white m-background-blue-system'
                    : 'm-color-white'
                }
                size="large"
                type="link"
                onClick={() => {
                  setSelectContainer(13);

                  window.open(
                    'https://metricsapi.gpoptima.info/Dashboard/demo8/src/html/indicadoresDiario.html?token=ahsuER3494asa',
                    '_blank',
                    'noopener,noreferrer',
                  );

                }}
              >
                <LinkOutlined />
              </Button>
            </Popover>
          </div>

          <div>
            <Button
              style={{ fontSize: 16 }}
              className="m-color-white"
              size="large"
              type="link"
              onClick={() => setSettingsVisible(true)}
            >
              <SettingOutlined />
            </Button>
            <Button
              style={{ fontSize: 16 }}
              className="m-color-white"
              size="large"
              type="link"
              onClick={() => setProfileVisible(true)}
            >
              <UserOutlined />
            </Button>
          </div>
        </div>
      </Sider>

      <Content>
        <div>
          <Switch>
            <Route exact path="/main">
              <Redirect
                to={
                  isRestrictedUser
                    ? '/main/evaluacionDesempeno'
                    : '/main/resumenEjecutivoGO'
                }
              />
            </Route>
            {!isRestrictedUser && (
              <>
                <Route
                  path="/main/resumenEjecutivoGO"
                  component={DealerProfile}
                />
                <Route path="/main/metrix" component={MainMetrico} />
                <Route path="/main/dashboard" component={MainDashboard} />
                <Route path="/main/reports" component={Reports} />
                <Route
                  path="/main/evaluacionOptima"
                  component={EvaluacionOptima}
                />
                <Route
                  path="/main/resumenGerencial"
                  component={resumenGerencial}
                />
                <Route
                  path="/main/evaluacionGarantias"
                  component={EvaluacionGarantias}
                />
                <Route
                  path="/main/dashboardServicios"
                  component={DashboardServicios}
                />
                <Route
                  path="/main/inventarioFisico"
                  component={InventarioFisico}
                />
                <Route
                  path="/main/inventarioRDSMxl"
                  component={inventarioRDSMxl}
                />
                <Route
                  path="/main/evaluacionDesempeno"
                  component={EvaluacionDesempeno}
                />
                <Route path="/main/meeting" component={Meeting} />
              </>
            )}
            <Route
              path="/main/evaluacionDesempeno"
              component={EvaluacionDesempeno}
            />
          </Switch>
        </div>
      </Content>
    </Layout>
  ) : (
    <Redirect to="/login" />
  );
}

export default Main;
